import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {日付書式} from '@/type/validation/validator';

import {遡及訂正登録依頼型} from '@/type/retrospective/retrospective';

export default class 価格登録遡及訂正入力チェッカー {
  単項目チェック結果: Error[];

  constructor(target: 遡及訂正登録依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果
      .map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '適用終了日',
    constraints: [
      {method: 日付書式, message: '適用終了日の書式を正しく入力してください'},
    ],
  },
];
